// src/components/FilteredTablePage.tsx
import React, { useState } from 'react';
import { Button, Card, Col, Collapse, Container } from 'react-bootstrap';
import ToolControlList from './ToolsControlList';
import useFetchTools from '../../hooks/useFetchTools';
import FilterTools from './FilterTools';
import ToolsAddModal from './ToolsAddModal';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import './../Devices/DeviceScanControl.css';

interface FilterCriteria {
  name: string;
  description: string;
}

const ToolsPage: React.FC = () => {
  const { t } = useTranslation();
  const [filterCriteria, setFilterCriteria] = useState<FilterCriteria>({ name: '', description: '', });
  const [showAddTool, setShowAddPurchase] = useState(false);
  const [emptyCriteria] = useState<FilterCriteria>({ name: '', description: '' });
  const { apiResponse, error } = useFetchTools(emptyCriteria);
  const [openFilter, setOpenFilter] = useState(false);

  const handleModalClose = () => setShowAddPurchase(false);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const filteredTools = apiResponse?.result?.filter(tool => {
    const searchName = filterCriteria.name.toLowerCase();
    const searchDesc = filterCriteria.description.toLowerCase();
    const translatedName = t(tool.name).toLowerCase();
    const translatedDesc = t(tool.description).toLowerCase();
    return translatedName.includes(searchName) && translatedDesc.includes(searchDesc);
  }) || [];

  return (
    <Container>
      <Card className="shadow m-3">
        <Card.Header className="bg-primary text-white clickable" onClick={() => setOpenFilter(!openFilter)} aria-controls="collapse-tools" aria-expanded={openFilter}>
          <Col>
            <Card.Title className="position-absolute top-0 start-50 translate-middle-x mt-2 fs-2">{t("tools.title")}</Card.Title>
          </Col>
          <Col className="d-flex justify-content-end">
            <Button className="button-scan" onClick={() => setShowAddPurchase(!showAddTool)}>
              <FontAwesomeIcon icon={faPlus} /> {t("add")}
            </Button>
          </Col>
        </Card.Header>
        <Collapse in={openFilter}>
          <div id="collapse-crm">
            <Card.Body>
              <FilterTools onFilterChange={setFilterCriteria} />
            </Card.Body>
          </div>
        </Collapse>
      </Card>
      {showAddTool && (
        <ToolsAddModal show={showAddTool} handleClose={handleModalClose} />
      )}
      <ToolControlList result={filteredTools} total={filteredTools.length} />
    </Container>
  );
};

export default ToolsPage;
